import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AppleDeviceProfileResolverActions } from '../apple-device-profile';
import { AppleDeviceProfileType } from '../apple-device-profile/apple-device-profile.types';
import { DevicesRouterStoreSelectors } from '../router';

export const appleDeviceProfileResolver: (profileType: AppleDeviceProfileType) => ResolveFn<boolean> = (
  profileType: AppleDeviceProfileType
) => {
  return () => {
    const store = inject(Store);

    return store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (udid) {
          store.dispatch(
            AppleDeviceProfileResolverActions.profileRequested({
              udid: udid,
              profileType,
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  };
};
